<template>
    <div class="datepicker-input">
        <input type="text" ref="datepicker" :placeholder="$t('monibox.date')" />
        <i class="fa-regular fa-calendar"></i>
    </div>
</template>

<script>
export default {
    name: "BasicDatepicker",
    data() {
        return {
            jquery: window.jQuery,
            value: null,
        }
    },

    emits: ["changeDate"],

    props: {
        modelValue: {
            type: String,
            default: null,
        },
    },

    methods: {
        initiateDatePicker() {
            let i18nJquery = {
                'en': 'en-GB',
                'fl': 'nl'
            }
            this.jquery.datepicker.setDefaults(
                this.jquery.datepicker.regional[i18nJquery[this.$i18n.locale] ?? this.$i18n.locale]
            )

            this.jquery(this.$refs.datepicker).datepicker({
                dateFormat: "dd/mm/yy",
                defaultDate: new Date(),
                buttonImage: "@/assets/images/icons/chevron-left-solid.svg",
                changeMonth: true,
                changeYear: true,
                onSelect: () => {
                    const fullDate = this.jquery(
                        this.$refs.datepicker
                    ).datepicker("getDate")

                    let formatedDate = this.jquery.datepicker.formatDate(
                        "yy-mm-dd",
                        fullDate
                    )

                    if (this.modelValue === formatedDate) {
                        formatedDate = null
                        this.$refs.datepicker.value = null
                    }

                    this.$emit("changeDate", formatedDate)
                },
            })

            let parsedData
            if (this.modelValue) {
                parsedData = this.jquery.datepicker.parseDate(
                    "yy-mm-dd",
                    this.modelValue
                )

                this.jquery(this.$refs.datepicker).datepicker(
                    "setDate",
                    parsedData
                )
            }
        },
    },

    mounted() {
        this.initiateDatePicker()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_loader.scss";
@import "@/assets/scss/details.scss";

.datepicker-input {
    width: 100%;
    font-family: $font-avenir-medium;
    border-radius: 10px;
    color: $blue-neutral;
    background-color: $light-grey;
    display: flex;
    align-items: center;
    position: relative;

    input {
        background-color: transparent;
        border: 0px;
        width: 100%;
        color: $blue-neutral;
        padding: 0 1em;
        min-height: 46px;

        &:focus {
            outline: none;
        }

        &:hover {
            cursor: pointer;
        }

        &::placeholder {
            color: $blue-neutral;
        }
    }

    i {
        position: absolute;
        display: flex;
        right: 1em;
    }
}
</style>
